export const PLACE_TYPES = {
  crematorium: 'Crematorium',
  receptionVenue: 'Reception Venue',
  dignityCrematorium: 'Dignity Crematorium',
}
